// 活動獎勵
'use client';
import { useSelector } from 'react-redux';
import { originURL } from '@/slices/originURLSlice';

const CampaignRewards = ({ drawTime, dailyAwardsAmount }) => {
    const { cmOrigin } = useSelector(originURL);

    return (
        <div id="rewards" className="pt-[60px] pb-[22px] ulg:pt-[50px] usm:!pt-[30px]">
            <h2>活動獎勵</h2>
            <div className="text-bd1m space-y-[22px] ulg:space-y-[20px]">
                <p>
                    本次活動將每天抽選出
                    <span className="text-[#29afcb]">{` ${dailyAwardsAmount} `}</span>
                    名幸運參與者，贈送活動限定獎勵。
                    中獎訊息將於活動結束後透過電子郵件通知，並以您在會員中心填寫的
                    <a
                        href={cmOrigin + 'claim-reward'}
                        className="text-[#29afcb]"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        領獎資料
                    </a>
                    ，來進行發獎。別忘了常查看您的信箱，好運可能已經降臨囉！
                </p>
                <p>抽獎時間: 每日 {drawTime}</p>
            </div>
        </div>
    );
};

export default CampaignRewards;
